/*
  CK Store — "Build your bundle" page (sections/ck-bundle-builder.liquid)  v2
  - Every product card has its own colour swatches + size buttons + "Add to bundle"
    (no popup to open: pick and add in one place, also on phones)
  - Bundle panel (desktop: sticky side panel · phone: bar above the store's bottom menu)
    with the offer steps, each piece with − / + quantity, and the estimated total
  - "View bundle" opens the summary sheet → one /cart/add.js request → cart page
  - The bundle is kept in sessionStorage so a refresh doesn't lose it
  - Cart sync: the items ALREADY in the cart are read from /cart.js and shown in the panel +
    summary (with − / + that change the real cart). They count toward the offer exactly like
    Shopify's automatic discount does (it counts every item in the cart). Kept in sync with the
    theme's "cart:updated" event (cart drawer, other tabs via back/forward, focus).
  The real discount is Shopify's AUTOMATIC discount; the numbers here are an estimate.
*/
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('ck-bundle-builder')) return;

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function formatMoney(cents, format) {
    cents = Math.round(cents);
    var fmt = format || '{{amount}}';
    if (cents % 100 === 0) {
      fmt = fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}')
               .replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}');
    }
    function d(n, p, t, dec) {
      var parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return fmt;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      default: v = d(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function shortName(p) {
    var n = p.name || p.title || '';
    if (n === p.title) n = n.split(/\s[–—-]\s/)[0];
    return n;
  }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (val === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  var ICON = {
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3.5-5-1.2C7 7 9.5 7 12 7zm0 0c1.5-3 5-3.5 5-1.2C17 7 14.5 7 12 7z"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    bag: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1 12H6zM9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    family: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="6" r="2.3"/><circle cx="17" cy="6" r="2.3"/><circle cx="12" cy="11" r="1.9"/><path d="M3.5 20v-5.5A3.5 3.5 0 0 1 7 11h0a3.5 3.5 0 0 1 2.2.8M20.5 20v-5.5A3.5 3.5 0 0 0 17 11h0a3.5 3.5 0 0 0-2.2.8M9.5 20v-3a2.5 2.5 0 0 1 5 0v3"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    up: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg>'
  };

  class CKBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.cfg = JSON.parse(this.querySelector('[data-ckbb-config]').textContent);
      } catch (e) { console.error('[ck-bundle-builder] bad config', e); return; }
      this.s = this.cfg.s || {};
      this.products = (this.cfg.products || []).filter(function (p) { return p && p.variants && p.variants.length; });
      this.byId = {};
      this.products.forEach(function (p) { this.byId[p.id] = p; }, this);
      this.groups = (this.cfg.groups || []).filter(function (g) { return g && g.ids && g.ids.length; });
      this.max = this.cfg.maxItems || 6;
      this.tiers = (this.cfg.tiers || []).filter(function (t) { return t.qty > 0 && t.pct > 0; })
        .sort(function (a, b) { return a.qty - b.qty; });
      this.group = -1;
      this.sel = {};
      this.lines = this.restore();
      this.cart = null;

      this.gridEl = this.querySelector('[data-ckbb-grid]');
      this.tabsEl = this.querySelector('[data-ckbb-tabs]');
      this.trayEl = this.querySelector('[data-ckbb-tray]');
      this.barEl = this.querySelector('[data-ckbb-bar]');
      this.summaryEl = this.querySelector('[data-ckbb-summary]');
      this.summaryBody = this.querySelector('[data-ckbb-summary-body]');
      this.toastEl = this.querySelector('[data-ckbb-toast]');

      // the sheet + bar must sit above the theme's fixed bottom menu and app buttons
      var dir = this.getAttribute('dir') || 'ltr';
      [this.barEl, this.summaryEl, this.toastEl].forEach(function (el) { document.body.appendChild(el); el.setAttribute('dir', dir); });

      this.bind();
      this.renderTabs();
      this.renderGrid();
      this.renderTray();
      this.watchBottom();
      this.watchCart();
    }

    /* ---------- live cart ---------- */
    watchCart() {
      var self = this;
      this.loadCart();
      document.addEventListener('cart:updated', function (e) {
        if (self._ownUpdate) return;
        var c = e && e.detail && e.detail.cart;
        if (c && c.items) self.setCart(c); else self.loadCart();
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.loadCart(); });
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') self.loadCart(); });
    }
    loadCart() {
      var self = this;
      return fetch(this.cfg.cartJsUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.setCart(c); return c; })
        .catch(function () {});
    }
    setCart(c) {
      this.cart = c;
      this.renderTray();
      this.renderGrid(true);
      if (this.summaryOpen) this.renderSummary();
    }
    cartItems() { return (this.cart && this.cart.items) || []; }
    cartCount() { return this.cart ? this.cart.item_count || 0 : 0; }
    allCount() { return this.count() + this.cartCount(); }
    broadcast(cart) {
      // header badge, cart drawer and the bottom menu follow the change
      this._ownUpdate = true;
      document.querySelectorAll('[data-js-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      this._ownUpdate = false;
    }
    changeCartLine(key, qty) {
      if (this._cartBusy) return;
      var self = this;
      this._cartBusy = true;
      this.querySelectorAll('[data-ckbb-cqty]').forEach(function (b) { b.disabled = true; });
      this.summaryEl.querySelectorAll('[data-ckbb-cqty]').forEach(function (b) { b.disabled = true; });
      fetch(this.cfg.cartChangeUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      }).then(function (r) { return r.json(); })
        .then(function (c) { self._cartBusy = false; if (c && c.items) { self.setCart(c); self.broadcast(c); } else self.loadCart(); })
        .catch(function () { self._cartBusy = false; self.loadCart(); });
    }

    /* ---------- state ---------- */
    money(c) { return formatMoney(c, this.cfg.moneyFormat); }
    restore() {
      var saved = store(this.cfg.storageKey) || [];
      var self = this, total = 0;
      return saved.map(function (l) {
        var p = self.byId[l.pid];
        var v = p && p.variants.find(function (x) { return x.id === l.vid && x.available; });
        if (!v) return null;
        var q = Math.max(1, Math.min(l.qty || 1, self.max - total));
        if (q <= 0) return null;
        total += q;
        return { pid: p.id, vid: v.id, qty: q };
      }).filter(Boolean);
    }
    save() { store(this.cfg.storageKey, this.lines.length ? this.lines : null); }
    count() { return this.lines.reduce(function (n, l) { return n + l.qty; }, 0); }
    countIn(pid) { return this.lines.reduce(function (n, l) { return n + (l.pid === pid ? l.qty : 0); }, 0); }
    info(line) {
      var p = this.byId[line.pid];
      var v = p.variants.find(function (x) { return x.id === line.vid; });
      var color = p.colorPos ? v.options[p.colorPos - 1] : '';
      var meta = p.hasOnlyDefault ? [] : v.options.filter(function (o, i) { return p.options[i].values.length > 1; });
      return {
        name: shortName(p), price: v.price,
        image: (color && p.colorImages && p.colorImages[color]) || p.image,
        meta: meta.join(' / ')
      };
    }
    pct(count) {
      if (this.cfg.offerOn === false) return 0;
      var pct = 0;
      this.tiers.forEach(function (t) { if (count >= t.qty) pct = t.pct; });
      return pct;
    }
    // 4+ pieces: Shopify applies the automatic "Family Pack" discount (Theme settings › CK — Bundle offer)
    isFamily(count) { return this.cfg.familyQty > 0 && count >= this.cfg.familyQty; }
    freeShip(count) { return this.cfg.freeShipQty > 0 && count >= this.cfg.freeShipQty; }
    totals() {
      var self = this, nb = this.count(), nc = this.cartCount(), n = nb + nc;
      var bundleSub = this.lines.reduce(function (s, l) { return s + self.info(l).price * l.qty; }, 0);
      var cartSub = this.cartItems().reduce(function (s, it) { return s + (it.original_line_price != null ? it.original_line_price : it.line_price || 0); }, 0);
      var sub = bundleSub + cartSub;
      var pct = this.pct(n);
      var disc = Math.round(sub * pct / 100);
      return { n: n, nb: nb, nc: nc, sub: sub, pct: pct, disc: disc, total: sub - disc, freeShip: this.freeShip(n) };
    }
    offerMessage() {
      var n = this.allCount(), s = this.s;
      if (this.cfg.offerOn === false || !this.tiers.length) return { text: '', best: false };
      var last = this.tiers[this.tiers.length - 1];
      var next = this.tiers.find(function (t) { return n < t.qty; });
      if (!next) return { text: fill(this.isFamily(n) && s.msg_best_family ? s.msg_best_family : s.msg_best, { pct: last.pct }), best: true };
      var left = next.qty - n;
      var shipNext = this.cfg.freeShipQty > 0 && next.qty >= this.cfg.freeShipQty && !this.freeShip(n);
      return { text: fill(s.msg_next, { left: left === 1 ? s.more_one : fill(s.more_n, { n: left }), pct: next.pct, ship: shipNext ? s.msg_ship : '' }) };
    }
    perk() {
      // what adding one more piece does — shown on every card
      if (this.cfg.offerOn === false || !this.tiers.length) return '';
      var n = this.allCount(), s = this.s;
      var hit = this.tiers.find(function (t) { return t.qty === n + 1; });
      if (hit) return fill(s.perk_unlock, { pct: hit.pct });
      var next = this.tiers.find(function (t) { return t.qty > n + 1; });
      if (next) return fill(s.perk_tier, { qty: next.qty, pct: next.pct });
      return fill(s.perk_best, { pct: this.tiers[this.tiers.length - 1].pct });
    }

    /* ---------- selection on the card ---------- */
    selFor(p) {
      if (this.sel[p.id]) return this.sel[p.id];
      var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      var sel = first.options.slice();
      // the size is chosen by the customer (avoids wrong sizes) unless there's only one
      if (p.sizePos && p.options[p.sizePos - 1].values.length > 1) sel[p.sizePos - 1] = null;
      this.sel[p.id] = sel;
      return sel;
    }
    variantFor(p, sel) {
      return p.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); });
    }
    valueAvailable(p, idx, value, sel) {
      return p.variants.some(function (v) {
        if (!v.available || v.options[idx] !== value) return false;
        return v.options.every(function (o, i) { return i === idx || i > idx || sel[i] == null || o === sel[i]; });
      });
    }
    pickValue(pid, idx, value) {
      var p = this.byId[pid];
      if (!p) return;
      var sel = this.selFor(p);
      sel[idx] = value;
      if (sel.indexOf(null) === -1) {
        var v = this.variantFor(p, sel);
        if (!v || !v.available) {
          var alt = p.variants.find(function (x) {
            return x.available && x.options[idx] === value && (!p.sizePos || x.options[p.sizePos - 1] === sel[p.sizePos - 1]);
          }) || p.variants.find(function (x) { return x.available && x.options[idx] === value; });
          if (alt) {
            var dropSize = p.sizePos && idx !== p.sizePos - 1 && alt.options[p.sizePos - 1] !== sel[p.sizePos - 1];
            this.sel[pid] = alt.options.slice();
            if (dropSize) this.sel[pid][p.sizePos - 1] = null;
          }
        }
      }
      this.renderCard(pid);
    }
    addFromCard(pid) {
      var p = this.byId[pid];
      if (!p) return;
      var sel = this.selFor(p);
      var card = this.gridEl.querySelector('[data-ckbb-card="' + pid + '"]');
      if (sel.indexOf(null) > -1) {
        if (card) {
          card.classList.remove('is-missing'); void card.offsetWidth; card.classList.add('is-missing');
          var row = card.querySelector('.ckbb-opts__row.is-needed');
          if (row && row.scrollIntoView) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        return;
      }
      var v = this.variantFor(p, sel);
      if (!v || !v.available) return;
      if (this.count() >= this.max) { this.toast(this.s.full); return; }
      var line = this.lines.find(function (l) { return l.vid === v.id; });
      if (line) line.qty++; else this.lines.push({ pid: p.id, vid: v.id, qty: 1 });
      this.changed();
      this.toast(this.s.added, true);
      if (card) { card.classList.add('is-added'); setTimeout(function () { card.classList.remove('is-added'); }, 700); }
      this.pulseBar();
    }
    setQty(vid, delta) {
      var line = this.lines.find(function (l) { return l.vid === vid; });
      if (!line) return;
      if (delta > 0 && this.count() >= this.max) { this.toast(this.s.full); return; }
      line.qty += delta;
      if (line.qty <= 0) this.lines = this.lines.filter(function (l) { return l !== line; });
      this.changed();
      if (this.summaryOpen) {
        if (this.allCount()) this.renderSummary(); else this.closeSummary();
      }
    }
    changed() {
      this.save();
      this.renderTray();
      this.renderGrid(true);
    }

    /* ---------- events ---------- */
    bind() {
      var self = this;
      function onClick(e) {
        var t;
        if ((t = e.target.closest('[data-ckbb-tab]'))) { self.group = parseInt(t.dataset.ckbbTab, 10); self.renderTabs(); self.renderGrid(); return; }
        if ((t = e.target.closest('[data-ckbb-opt]'))) { var a = t.dataset.ckbbOpt.split(':'); self.pickValue(parseInt(a[0], 10), parseInt(a[1], 10), t.dataset.value); return; }
        if ((t = e.target.closest('[data-ckbb-add]'))) { self.addFromCard(parseInt(t.dataset.ckbbAdd, 10)); return; }
        if ((t = e.target.closest('[data-ckbb-cqty]'))) { self.changeCartLine(t.dataset.key, parseInt(t.dataset.qty, 10)); return; }
        if ((t = e.target.closest('[data-ckbb-qty]'))) { self.setQty(parseInt(t.dataset.vid, 10), parseInt(t.dataset.ckbbQty, 10)); return; }
        if (e.target.closest('[data-ckbb-close]')) { self.closeSummary(); return; }
        if ((t = e.target.closest('[data-ckbb-review]'))) { self.openSummary(t); return; }
        if (e.target.closest('[data-ckbb-checkout]')) { self.checkout(e.target.closest('[data-ckbb-checkout]')); return; }
        if (e.target.closest('[data-ckbb-scroll-shop]')) { self.closeSummary(); self.gridEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
      this.addEventListener('click', onClick);
      this.summaryEl.addEventListener('click', onClick);
      this.barEl.addEventListener('click', onClick);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.summaryOpen) self.closeSummary(); });
    }

    /* ---------- grid ---------- */
    renderTabs() {
      if (this.groups.length < 2) { this.tabsEl.hidden = true; return; }
      var self = this;
      var tabs = [{ i: -1, title: this.s.all, n: this.products.length }].concat(this.groups.map(function (g, i) {
        return { i: i, title: g.title, n: g.ids.filter(function (id) { return self.byId[id]; }).length };
      }));
      this.tabsEl.innerHTML = tabs.map(function (t) {
        var on = t.i === self.group;
        return '<button type="button" role="tab" class="ckbb__tab' + (on ? ' is-active' : '') + '" aria-selected="' + on + '" data-ckbb-tab="' + t.i + '">' +
          esc(t.title) + '<span>' + t.n + '</span></button>';
      }).join('');
    }
    renderGrid(keep) {
      var self = this, html = '';
      if (this.group < 0 && this.groups.length > 1) {
        var seen = {};
        this.groups.forEach(function (g) {
          var list = g.ids.map(function (id) { return self.byId[id]; }).filter(function (p) { return p && !seen[p.id]; });
          list.forEach(function (p) { seen[p.id] = 1; });
          if (!list.length) return;
          html += '<h2 class="ckbb__group-title">' + esc(g.title) + '</h2><div class="ckbb__grid">' + list.map(function (p) { return self.cardHTML(p); }).join('') + '</div>';
        });
        var rest = this.products.filter(function (p) { return !seen[p.id]; });
        if (rest.length) html += '<div class="ckbb__grid">' + rest.map(function (p) { return self.cardHTML(p); }).join('') + '</div>';
      } else {
        var g = this.groups[this.group];
        var list = this.group < 0 || !g ? this.products : g.ids.map(function (id) { return self.byId[id]; }).filter(Boolean);
        html = list.length ? '<div class="ckbb__grid">' + list.map(function (p) { return self.cardHTML(p); }).join('') + '</div>'
          : '<p class="ckbb__none">' + esc(this.s.no_products) + '</p>';
      }
      if (keep && this.gridEl.innerHTML) {
        // only the badges/perks change after adding: patch the cards instead of redrawing (keeps images)
        this.products.forEach(function (p) {
          var card = self.gridEl.querySelector('[data-ckbb-card="' + p.id + '"]');
          if (card) self.patchCard(card, p);
        });
        return;
      }
      this.gridEl.innerHTML = html;
    }
    renderCard(pid) {
      var card = this.gridEl.querySelector('[data-ckbb-card="' + pid + '"]');
      if (!card) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = this.cardHTML(this.byId[pid]);
      var fresh = tmp.firstChild;
      // keep the loaded <img> element when the picture doesn't change (no flicker)
      var oldImg = card.querySelector('.ckbb-card__media img'), newImg = fresh.querySelector('.ckbb-card__media img');
      if (oldImg && newImg && oldImg.getAttribute('src') === newImg.getAttribute('src')) newImg.replaceWith(oldImg);
      card.replaceWith(fresh);
    }
    patchCard(card, p) {
      var n = this.countIn(p.id);
      card.classList.toggle('is-in', n > 0);
      var badge = card.querySelector('.ckbb-card__badge');
      if (badge) { badge.hidden = !n; badge.querySelector('b').textContent = '×' + n; }
      var perk = card.querySelector('.ckbb-card__perk span');
      if (perk) perk.textContent = this.perk();
      var full = this.count() >= this.max;
      var btn = card.querySelector('[data-ckbb-add]');
      if (btn) btn.classList.toggle('is-full', full);
    }
    cardHTML(p) {
      var self = this, s = this.s, sel = this.selFor(p);
      var v = sel.indexOf(null) === -1 ? this.variantFor(p, sel) : null;
      var prices = p.variants.filter(function (x) { return x.available; }).map(function (x) { return x.price; });
      if (!prices.length) prices = p.variants.map(function (x) { return x.price; });
      var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
      var price = v ? this.money(v.price) : (min === max ? this.money(min) : fill(s.from, { price: this.money(min) }));
      var color = p.colorPos ? sel[p.colorPos - 1] : null;
      var img = (color && p.colorImages && p.colorImages[color]) || p.image;
      var n = this.countIn(p.id);
      var perk = this.perk();

      var opts = p.hasOnlyDefault ? '' : p.options.map(function (o, idx) {
        if (o.values.length < 2) return '';
        var isColor = p.colorPos === idx + 1;
        var chosen = sel[idx];
        var vals = o.values.map(function (val) {
          var ok = self.valueAvailable(p, idx, val.name, sel);
          var on = chosen === val.name;
          var cls = (isColor ? 'ckbb-sw' : 'ckbb-chip') + (on ? ' is-on' : '') + (ok ? '' : ' is-out');
          var inner = isColor
            ? '<span style="' + (val.img ? 'background-image:url(' + esc(val.img) + ')' : (val.hex ? 'background:' + esc(val.hex) : 'background:#ddd')) + '"></span>'
            : esc(val.name);
          return '<button type="button" class="' + cls + '" data-ckbb-opt="' + p.id + ':' + idx + '" data-value="' + esc(val.name) + '" aria-pressed="' + on + '"' +
            ' aria-label="' + esc(o.name + ': ' + val.name) + '"' + (isColor ? ' title="' + esc(val.name) + '"' : '') + '>' + inner + '</button>';
        }).join('');
        return '<div class="ckbb-opts__row' + (chosen == null ? ' is-needed' : '') + '">' +
          '<p class="ckbb-opts__label">' + esc(o.name) + (chosen ? ': <strong>' + esc(chosen) + '</strong>' : ' <em>' + esc(s.required) + '</em>') + '</p>' +
          '<div class="ckbb-opts__vals' + (isColor ? ' is-sw' : '') + '">' + vals + '</div></div>';
      }).join('');

      var missing = p.options.find(function (o, i) { return sel[i] == null; });
      var label, soldOut = !missing && (!v || !v.available);
      if (missing) label = fill(s.select, { name: missing.name });
      else if (soldOut) label = s.sold_out;
      else label = s.add;

      return '<article class="ckbb-card' + (n ? ' is-in' : '') + '" data-ckbb-card="' + p.id + '">' +
        '<div class="ckbb-card__media">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="480" height="480">' : '') +
          '<span class="ckbb-card__badge"' + (n ? '' : ' hidden') + '>' + ICON.check + '<b>×' + n + '</b></span>' +
        '</div>' +
        '<div class="ckbb-card__info">' +
          '<h3 class="ckbb-card__name">' + esc(shortName(p)) + '</h3>' +
          '<p class="ckbb-card__price">' + esc(price) + '</p>' +
          (perk ? '<p class="ckbb-card__perk">' + ICON.gift + '<span>' + esc(perk) + '</span></p>' : '') +
          '<div class="ckbb-opts">' + opts + '</div>' +
          '<button type="button" class="ckbb-add' + (missing ? ' is-pending' : '') + (this.count() >= this.max ? ' is-full' : '') + '" data-ckbb-add="' + p.id + '"' + (soldOut ? ' disabled' : '') + '>' +
            (missing || soldOut ? '' : ICON.plus) + '<span>' + esc(label) + '</span></button>' +
        '</div></article>';
    }

    /* ---------- offer steps ---------- */
    stepsHTML() {
      if (this.cfg.offerOn === false || !this.tiers.length) return '';
      var self = this, s = this.s, n = this.allCount();
      var last = this.tiers[this.tiers.length - 1].qty;
      var steps = [];
      for (var q = 1; q <= last; q++) steps.push(q);
      var fillPct = Math.min(Math.max(n - 1, 0) / (last - 1 || 1), 1) * 100;
      return '<div class="ckbb-steps" style="--fill:' + fillPct + '%">' +
        '<div class="ckbb-steps__track"><i></i></div>' +
        steps.map(function (q) {
          var t = self.tiers.find(function (x) { return x.qty === q; });
          var on = n >= q;
          var lbl = q === 1 ? s.full_price : (t ? '−' + t.pct + '%' : '');
          var ship = q > 1 && self.cfg.freeShipQty > 0 && q >= self.cfg.freeShipQty && (t || q === self.cfg.freeShipQty) ? s.free_ship_short : '';
          return '<div class="ckbb-steps__step' + (on ? ' is-on' : '') + (q === last ? ' is-best' : '') + '">' +
            '<span class="ckbb-steps__dot">' + (on && q < last ? ICON.check : q) + '</span>' +
            '<strong>' + (t && q > 1 ? '<bdi dir="ltr">' + esc(lbl) + '</bdi>' : esc(lbl)) + '</strong>' + (ship ? '<small>' + esc(ship) + '</small>' : '') + '</div>';
        }).join('') + '</div>';
    }

    /* ---------- tray (desktop) + bar (phone) ---------- */
    linesHTML(cls) {
      var self = this, s = this.s;
      return '<ul class="' + cls + '" role="list">' + this.lines.map(function (l) {
        var i = self.info(l);
        return '<li><img src="' + esc(i.image || '') + '" alt="" loading="lazy">' +
          '<div class="ckbb-line__txt"><strong>' + esc(i.name) + '</strong><span>' + esc(i.meta) + '</span><em>' + esc(self.money(i.price * l.qty)) + '</em></div>' +
          '<div class="ckbb-qty" role="group">' +
            '<button type="button" data-ckbb-qty="-1" data-vid="' + l.vid + '" aria-label="' + esc(s.dec) + '">' + (l.qty === 1 ? ICON.trash : ICON.minus) + '</button>' +
            '<output>' + l.qty + '</output>' +
            '<button type="button" data-ckbb-qty="1" data-vid="' + l.vid + '" aria-label="' + esc(s.inc) + '"' + (self.count() >= self.max ? ' disabled' : '') + '>' + ICON.plus + '</button>' +
          '</div></li>';
      }).join('') + '</ul>';
    }
    cartLinesHTML() {
      var self = this, s = this.s, items = this.cartItems();
      if (!items.length) return '';
      return '<div class="ckbb-block ckbb-block--cart"><p class="ckbb-block__title">' + ICON.bag + '<span>' + esc(s.in_cart) + '</span><b>' + this.cartCount() + '</b></p>' +
        '<ul class="ckbb-lines ckbb-lines--cart" role="list">' + items.map(function (it) {
          var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          var meta = it.variant_title && !/default title/i.test(it.variant_title) ? it.variant_title : '';
          var price = it.original_line_price != null ? it.original_line_price : it.line_price;
          return '<li><img src="' + esc(img) + '" alt="" loading="lazy">' +
            '<div class="ckbb-line__txt"><strong>' + esc(it.product_title || it.title) + '</strong><span>' + esc(meta) + '</span><em>' + esc(self.money(price)) + '</em></div>' +
            '<div class="ckbb-qty" role="group">' +
              '<button type="button" data-ckbb-cqty data-key="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '" aria-label="' + esc(s.dec) + '">' + (it.quantity === 1 ? ICON.trash : ICON.minus) + '</button>' +
              '<output>' + it.quantity + '</output>' +
              '<button type="button" data-ckbb-cqty data-key="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '" aria-label="' + esc(s.inc) + '">' + ICON.plus + '</button>' +
            '</div></li>';
        }).join('') + '</ul><p class="ckbb-block__note">' + esc(s.cart_note) + '</p></div>';
    }
    bundleBlockHTML() {
      if (!this.lines.length) return '';
      var s = this.s;
      return '<div class="ckbb-block ckbb-block--new"><p class="ckbb-block__title">' + ICON.gift + '<span>' + esc(s.new_pieces) + '</span><b>' + this.count() + '</b></p>' +
        this.linesHTML('ckbb-lines') + '</div>';
    }
    sumHTML(t, checkout) {
      var s = this.s;
      return '<dl class="ckbb-sum">' +
        '<div><dt>' + esc(s.subtotal) + '</dt><dd>' + esc(this.money(t.sub)) + '</dd></div>' +
        (t.disc ? '<div class="is-save"><dt>' + esc(fill(this.isFamily(t.n) && s.discount_family ? s.discount_family : s.discount, { pct: t.pct })) + '</dt><dd><bdi dir="ltr">−' + esc(this.money(t.disc)) + '</bdi></dd></div>' : '') +
        '<div' + (t.freeShip ? ' class="is-save"' : '') + '><dt>' + ICON.truck + esc(s.shipping) + '</dt><dd>' + esc(t.freeShip ? s.free : s.at_checkout) + '</dd></div>' +
        '<div class="is-total"><dt>' + esc(s.total) + '</dt><dd>' + (t.disc ? '<s><bdi>' + esc(this.money(t.sub)) + '</bdi></s>' : '') + '<bdi>' + esc(this.money(t.total)) + '</bdi></dd></div>' +
        '</dl>' +
        (t.disc ? '<p class="ckbb-saved">' + ICON.check + esc(fill(s.you_save, { amount: this.money(t.disc) })) + '</p>' : '');
    }
    renderTray() {
      var s = this.s, t = this.totals(), msg = this.offerMessage(), n = t.n;
      this.trayEl.innerHTML =
        '<div class="ckbb-tray__head">' + ICON.family + '<h2>' + esc(s.your_bundle) + '</h2><span>' + esc(n === 1 ? s.piece_one : fill(s.pieces, { count: n })) + '</span></div>' +
        '<div class="ckbb-tray__body">' +
          this.stepsHTML() +
          (msg.text ? '<p class="ckbb-msg' + (msg.best ? ' is-best' : '') + '">' + ICON.gift + '<span>' + esc(msg.text) + '</span></p>' : '') +
          (t.nb ? this.bundleBlockHTML() : '<p class="ckbb-empty">' + esc(s.empty) + '</p>') +
          this.cartLinesHTML() +
          (n ? this.sumHTML(t) : '') +
          '<button type="button" class="ckbb-cta" data-ckbb-review' + (n ? '' : ' disabled') + '>' + esc(t.nb ? s.review : s.view_cart) + ICON.arrow + '</button>' +
          '<p class="ckbb-note">' + ICON.check + esc(s.summary_note) + '</p>' +
        '</div>';

      // phone bar
      var pics = this.lines.map(function (l) { return this.info(l).image || ''; }, this)
        .concat(this.cartItems().map(function (it) { return it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; }));
      var thumbs = pics.slice(0, 3).map(function (src) { return '<img src="' + esc(src) + '" alt="">'; }).join('');
      this.barEl.classList.toggle('is-empty', !n);
      this.barEl.innerHTML =
        (msg.text ? '<p class="ckbb-bar__msg' + (msg.best ? ' is-best' : '') + '">' + ICON.gift + '<span>' + esc(msg.text) + '</span></p>' : '') +
        '<div class="ckbb-bar__row">' +
          '<button type="button" class="ckbb-bar__info" data-ckbb-review' + (n ? '' : ' disabled') + ' aria-label="' + esc(s.view) + '">' +
            '<span class="ckbb-bar__thumbs">' + (thumbs || '<i>' + ICON.bag + '</i>') + (n ? '<b>' + n + '</b>' : '') + '</span>' +
            '<span class="ckbb-bar__txt"><strong>' + esc(this.money(t.total)) + '</strong>' +
              (t.disc ? '<s><bdi>' + esc(this.money(t.sub)) + '</bdi></s>' : '<small>' + esc(n === 1 ? s.piece_one : fill(s.pieces, { count: n })) + '</small>') + '</span>' +
          '</button>' +
          '<button type="button" class="ckbb-bar__btn" data-ckbb-review' + (n ? '' : ' disabled') + '>' + esc(s.view) + ICON.up + '</button>' +
        '</div>';
      this.measureBar();
    }
    pulseBar() {
      var b = this.barEl;
      b.classList.remove('is-pulse'); void b.offsetWidth; b.classList.add('is-pulse');
    }

    /* ---------- keep clear of the store's bottom menu + floating app buttons ---------- */
    watchBottom() {
      var self = this;
      var update = function () { self.measureBar(); };
      window.addEventListener('resize', update);
      window.addEventListener('orientationchange', update);
      if (window.ResizeObserver) {
        var nav = document.querySelector('.ck-bottom-bar');
        var ro = new ResizeObserver(update);
        ro.observe(this.barEl);
        if (nav) ro.observe(nav);
      }
      // floating chat buttons (WhatsApp app) load late
      [600, 2000, 5000].forEach(function (ms) { setTimeout(update, ms); });
    }
    measureBar() {
      var nav = document.querySelector('.ck-bottom-bar');
      var navH = 0;
      if (nav) {
        var cs = getComputedStyle(nav);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && cs.position === 'fixed') navH = nav.getBoundingClientRect().height;
      }
      var barVisible = getComputedStyle(this.barEl).display !== 'none';
      var barH = barVisible ? this.barEl.getBoundingClientRect().height : 0;
      this.style.setProperty('--ckbb-nav-h', navH + 'px');
      this.style.setProperty('--ckbb-bar-h', barH + 'px');
      [this.summaryEl, this.barEl, this.toastEl].forEach(function (el) {
        el.style.setProperty('--ckbb-nav-h', navH + 'px');
        el.style.setProperty('--ckbb-bar-h', barH + 'px');
      });
      this.liftFloating(barVisible ? barH : 0);
    }
    liftFloating(h) {
      var self = this;
      var found = document.querySelectorAll('[id*="whatsapp" i],[class*="whatsapp" i],[id*="wa-chat" i],[class*="wa-chat" i],[class*="wa_chat" i]');
      var fixed = Array.prototype.filter.call(found, function (el) {
        return !self.contains(el) && !self.barEl.contains(el) && !self.summaryEl.contains(el) && getComputedStyle(el).position === 'fixed';
      });
      fixed.forEach(function (el) {
        if (fixed.some(function (o) { return o !== el && o.contains(el); })) return;
        el.style.setProperty('transition', 'transform .3s ease');
        el.style.setProperty('transform', h ? 'translateY(-' + Math.round(h) + 'px)' : 'none', 'important');
      });
    }

    /* ---------- summary sheet ---------- */
    openSummary(opener) {
      if (!this.allCount()) return;
      this.renderSummary();
      var el = this.summaryEl;
      this.opener = opener || document.activeElement;
      this.summaryOpen = true;
      el.hidden = false;
      this.toastEl.classList.remove('is-open');
      document.documentElement.classList.add('ckbb-lock');
      requestAnimationFrame(function () { el.classList.add('is-open'); el.querySelector('[role="dialog"]').focus({ preventScroll: true }); });
    }
    closeSummary() {
      var el = this.summaryEl;
      if (!this.summaryOpen) return;
      this.summaryOpen = false;
      el.classList.remove('is-open');
      document.documentElement.classList.remove('ckbb-lock');
      setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 260);
      if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
    }
    renderSummary(error) {
      var s = this.s, t = this.totals(), msg = this.offerMessage();
      this.summaryBody.setAttribute('aria-label', s.summary_title);
      this.summaryBody.innerHTML =
        '<header class="ckbb-sheet__head">' +
          '<span class="ckbb-sheet__grip" aria-hidden="true"></span>' +
          '<div><h2>' + esc(s.summary_title) + '</h2><p>' + esc(t.n === 1 ? s.piece_one : fill(s.pieces, { count: t.n })) + '</p></div>' +
          '<button type="button" class="ckbb-sheet__x" data-ckbb-close aria-label="' + esc(s.close) + '">' + ICON.close + '</button>' +
        '</header>' +
        '<div class="ckbb-sheet__body">' +
          this.stepsHTML() +
          (msg.text ? '<p class="ckbb-msg' + (msg.best ? ' is-best' : '') + '">' + ICON.gift + '<span>' + esc(msg.text) + '</span>' +
            (msg.best ? '' : ' <button type="button" data-ckbb-scroll-shop>' + esc(s.add_more) + '</button>') + '</p>' : '') +
          this.bundleBlockHTML() +
          this.cartLinesHTML() +
        '</div>' +
        '<footer class="ckbb-sheet__foot">' +
          this.sumHTML(t) +
          (error ? '<p class="ckbb-err" role="alert">' + esc(error) + '</p>' : '') +
          (t.nb ? '<button type="button" class="ckbb-cta" data-ckbb-checkout>' + ICON.bag + esc(s.checkout) + '</button>'
                : '<a class="ckbb-cta" href="' + esc(this.cfg.cartUrl) + '">' + ICON.bag + esc(s.go_cart) + '</a>') +
          '<button type="button" class="ckbb-link" data-ckbb-close>' + esc(s.keep) + '</button>' +
        '</footer>';
    }
    checkout(btn) {
      if (this.busy || !this.lines.length) return;
      var self = this;
      this.busy = true;
      btn.disabled = true;
      btn.textContent = this.s.adding;
      var id = 'B' + Date.now().toString(36).toUpperCase();
      var items = this.lines.map(function (l) { return { id: l.vid, quantity: l.qty, properties: { _bundle: id } }; });
      fetch(this.cfg.cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || ''); return data; });
      }).then(function () {
        store(self.cfg.storageKey, null);
        self.lines = [];
        document.dispatchEvent(new CustomEvent('ck:bundle-added', { bubbles: true }));
        window.location.href = self.cfg.cartUrl;
      }).catch(function (err) {
        self.busy = false;
        self.renderSummary(err && err.message ? err.message : self.s.error);
      });
    }

    toast(text, ok) {
      var el = this.toastEl;
      el.innerHTML = (ok ? ICON.check : '') + '<span>' + esc(text) + '</span>';
      el.classList.add('is-open');
      clearTimeout(this._t);
      this._t = setTimeout(function () { el.classList.remove('is-open'); }, 1800);
    }
  }

  customElements.define('ck-bundle-builder', CKBundleBuilder);
})();
